/* eslint-disable default-param-last */
export const UPDATE_VERSION = 'UPDATE_VERSION'

type VersionState = {
  name: string
  projectVersion: string
  envVersion: string
  buildNumber: string
  date: string
  host: string
}

type Action = {
  type: string
  payload?: VersionState
}

const initState: VersionState = {
  name: '',
  projectVersion: '',
  envVersion: '',
  buildNumber: '',
  date: '',
  host: ''
}

export default (
  state: VersionState = initState,
  action: Action
): VersionState => {
  switch (action.type) {
    case UPDATE_VERSION: {
      const payload = action.payload || initState
      return {
        ...state,
        name: payload.name || '',
        projectVersion: payload.projectVersion || '',
        envVersion: payload.envVersion || '',
        buildNumber: payload.buildNumber || '',
        date: payload.date || '',
        host: payload.host || ''
      }
    }
    default:
      return state
  }
}
